module.exports = __webpack_public_path__ + "static/media/shixisheng1.10aca9b1.png";